"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fFTMagitudesToFlatMap = exports.getFFTMagnitudes = void 0;
const tslib_1 = require("tslib");
const fft_js_1 = tslib_1.__importDefault(require("fft.js"));
const nextPowerOfTwo = (n) => {
    return Math.pow(2, Math.ceil(Math.log2(n)));
};
/** Returns the average magnitude of frequency bands from a time-domain signal.
 * This function works like an audio equalizer (EQ) output, showing how strong different frequency ranges are in your data. It splits your signal into bands (like bass, mid, treble in music) and tells you how much energy is in each band.
 * arr - Array of time-domain samples (e.g., acceleration data)
 * sampleRate - Sample rate of the data in Hz
 * numBands - Number of frequency bands to group the FFT result into (default: 20)
 * @returns Array mapping frequency range strings to average magnitudes
 */
const getFFTMagnitudes = ({ arr, sampleRate, numBands = 10, labelizer }) => {
    const labelFn = labelizer ?? ((lo, hi) => `${lo.toFixed(2)}-${hi.toFixed(2)}Hz`);
    let size = arr.length;
    if (size <= 1 || (size & (size - 1)) !== 0) {
        size = nextPowerOfTwo(Math.max(2, size));
        arr = [...arr, ...Array(size - arr.length).fill(0)];
    }
    const f = new fft_js_1.default(size);
    const out = f.createComplexArray();
    f.realTransform(out, arr);
    // Group bins into bands
    const bandSize = Math.floor(size / numBands);
    const res = [];
    for (let band = 0; band < numBands; band++) {
        let sum = 0;
        let start = band * bandSize;
        let end = band === numBands - 1 ? size : (band + 1) * bandSize;
        for (let i = start; i < end; i++) {
            const real = out[2 * i];
            const imag = out[2 * i + 1];
            sum += Math.sqrt(real * real + imag * imag);
        }
        const lo = (start * sampleRate) / size;
        const hi = ((end - 1) * sampleRate) / size;
        const label = labelFn(hi, lo);
        res.push({ fRange: [lo, hi], label, magnitude: sum / (end - start) });
    }
    return res;
};
exports.getFFTMagnitudes = getFFTMagnitudes;
/** output helper for FFT Mags, suitable for GSheets etc */
const fFTMagitudesToFlatMap = (ffrMags) => {
    return Object.fromEntries(ffrMags.map((v) => {
        return [v.label, v.magnitude];
    }));
};
exports.fFTMagitudesToFlatMap = fFTMagitudesToFlatMap;
